import { axiosInstance } from "./index";
import { isApiErrorCode } from "@/shared/utils/apiError";

export type PayeeEntityType = "individual" | "company";
export type DeclaredVia = "onboarding" | "terms_acceptance" | "profile_update";

/** The creator's live tax declaration. The registration number itself is never returned, only its last four. */
export interface TaxDeclaration {
	id: string;
	userId: string;
	countryCode: string;
	entityType: PayeeEntityType | "trust";
	legalName: string;
	isTaxRegistered: boolean;
	registrationNumberLast4: string | null;
	declaredVia: DeclaredVia | "backfill";
	declaredAt: string;
	supersededAt: string | null;
}

export interface TaxDeclarationInput {
	countryCode: string;
	entityType: PayeeEntityType;
	legalName: string;
	isTaxRegistered: boolean;
	registrationNumber?: string | null;
	declaredVia: DeclaredVia;
}

export type TaxDeclarationErrorCode =
	| "TAX_NUMBER_INVALID"
	| "ENTITY_TYPE_INVALID"
	| "LEGAL_NAME_REQUIRED"
	| "COUNTRY_NOT_CONFIGURED"
	| "TAX_DECLARATION_MISSING";

export const taxDeclarationAPI = {
	/** Null when the creator has not declared yet. */
	getMine: async (): Promise<TaxDeclaration | null> => {
		try {
			return (await axiosInstance.get("/creators/me/tax-declaration")).data;
		} catch (error) {
			if (isApiErrorCode(error, "TAX_DECLARATION_MISSING", 404)) return null;
			throw error;
		}
	},
	/** Append-only: every call records a new declaration and supersedes the previous one. */
	declare: async (input: TaxDeclarationInput, timeout?: number): Promise<TaxDeclaration> =>
		(await axiosInstance.post("/creators/me/tax-declaration", input, { timeout })).data,
};
